/**
 * @generated SignedSource<<fa4aa615ac75079c8d02834b15338a68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileLocation_tradeFirm$data = {
  readonly publicProfile: {
    readonly displayLocation: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "ProfileLocation_tradeFirm";
};
export type ProfileLocation_tradeFirm$key = {
  readonly " $data"?: ProfileLocation_tradeFirm$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileLocation_tradeFirm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileLocation_tradeFirm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayLocation",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TradeFirmType",
  "abstractKey": null
};

(node as any).hash = "56154d556ad284fea99199646a4ce4a4";

export default node;
